import React, { useState } from 'react';
import { TableCell, TableRow, Button } from "@mui/material";
import ViewIcon from "../../../../../../assets/images/icon_actions/View.svg";
import EditIcon from "../../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../../assets/images/icon_actions/Delete Icon.svg";
import { Image, Space, Modal } from "antd";
import { NavLink } from "react-router-dom";

export const LineTable = (props) => {
    const { classes, headerView, clsx, lines, getColumnWidth, loadMore, deleteLine, idNamingConversion,
        productLineHead, onEdit, checkCRUDPermission, capitalizeFirstLetter, roleManagement } = props;

    const [lineId, setLineId] = useState('');
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [lineName, setLineName] = useState('');

    const onDelete = (data, i) => {
        setDeleteVisible(true);
        setLineId(i);
        setLineName(data?.product?.productName);
    }

    return (
        <>
            {
                !loadMore || lines === '' ? (
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell className={classes.textAlignCenter} colSpan={productLineHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                    </TableRow>
                ) : (
                    <React.Fragment>
                        {
                            lines && Array.isArray(lines) && lines.length > 0 ? lines.map((data, i) => (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i} >
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 0) }}>
                                        {
                                            roleManagement !== '' && checkCRUDPermission('Customer Products', 'view', 'Sales') ?
                                                <NavLink to={'#'} id={idNamingConversion('View_' + data.id, 'customerProductsLine', 'Link')} onClick={() => onEdit(data, i, true)} className={clsx(classes.color, classes.bold)} style={{ width: getColumnWidth(productLineHead, 0) }}>{data?.product?.productName || '---'}</NavLink> :
                                                <span style={{ width: getColumnWidth(productLineHead, 0) }}>{data?.product?.productName || '---'}</span>
                                        }
                                    </TableCell>
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 1) }}><span style={{ width: getColumnWidth(productLineHead, 1) }}>{data?.product?.productId || '---'}</span></TableCell>
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 2) }}><span style={{ width: getColumnWidth(productLineHead, 2) }}></span>{capitalizeFirstLetter(data?.status || '---')}</TableCell>
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 3) }}><span style={{ width: getColumnWidth(productLineHead, 3) }}>{data?.quantity || '---'}</span></TableCell>
                                    <TableCell style={{ width: getColumnWidth(productLineHead, 4) }}><span style={{ width: getColumnWidth(productLineHead, 4) }}>{data?.unit?.name || '---'}</span></TableCell>
                                    <TableCell>
                                        <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding)}>
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Customer Products', 'view', 'Sales') &&
                                                <NavLink to={"#"} id={idNamingConversion('View_' + data.id, 'customerProductsLine', 'Icon')} onClick={() => onEdit(data, i, true)}>
                                                    <Image src={ViewIcon} preview={false} />
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Customer Products', 'edit', 'Sales') && <>
                                                    {
                                                        !headerView && <NavLink id={idNamingConversion('Edit_' + data.id, 'customerProductsLine', 'Icon')} to={"#"} onClick={() => onEdit(data, i, false)}>
                                                            <Image
                                                                src={EditIcon}
                                                                preview={false}
                                                            />
                                                        </NavLink>
                                                    }
                                                </>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Customer Products', 'deletable', 'Sales') && <>
                                                    {
                                                        !headerView &&
                                                        <NavLink to={"#"} id={idNamingConversion('Delete_' + data.id, 'customerProductsLine', 'Icon')} onClick={() => onDelete(data, i)}>
                                                            <Image src={DeleteIcon} preview={false} />
                                                        </NavLink>
                                                    }
                                                </>
                                            }
                                        </Space>
                                    </TableCell>
                                </TableRow>
                            )) : (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={productLineHead.length}>
                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by Adding Lines to your Product'}</p>
                                    </TableCell>
                                </TableRow>
                            )
                        }
                    </React.Fragment>
                )
            }
            <Modal
                title={'Delete Confirmation'}
                open={deleteVisible}
                onOk={() => setDeleteVisible(false)}
                onCancel={() => setDeleteVisible(false)}
                className={clsx(classes.commonPopup, classes.deletePopup, classes.removeUnderline)}
                footer={[
                    <Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn)}
                        onClick={() => { setDeleteVisible(false); deleteLine(lineId) }}
                    >Yes</Button>,
                    <Button
                        key="no"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, classes.AddMoreBtn)}
                        onClick={() => setDeleteVisible(false)}>
                        No
                    </Button>,
                ]}>
                <p>Are you sure you want to <span className={classes.deleteRed}> Delete </span> {lineName}</p>
            </Modal>
        </>

    )
}